<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Cleaner Comparison</h4>
    <hr >
    <div 
      v-if="isFetching" 
      style="margin: 0 auto; width: 10px;">
      <div class="loader-dark-blue medium mb-5 mt-5"/>
    </div>
    <b-row v-show="!isFetching">
      <b-col>
        <cleaner-comparison-chart 
          v-if="!isFetching" 
          :chart-data="chartData"/>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import reverse from 'lodash/reverse'

import { server } from '@/services/'
import { CleanerComparisonChart } from '@/components/'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'

export default {
  name: 'CleanerComparison',
  components: {
    CleanerComparisonChart
  },
  data () {
    return {
      isFetching: false,
      chartData: []
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.isFetching = true
      const brandWarning = getStyle('--warning')
      const brandSuccess = getStyle('--success')
      server.get('/ops/rptCostVsBudgetCL_LatestThreeMonth').then(
        resp => {
          let arr = resp.data.msgContent.data
          arr = reverse(arr)

          let dataTmp = [
            {
              label: 'Cost/Month',
              data: arr.map(obj => obj.WASH_COST_PER_MONTH),
              backgroundColor: hexToRgba(brandWarning, 10),
              borderColor: brandWarning,
              borderWidth: 2
            },
            {
              label: 'Budget/Month',
              data: arr.map(obj => obj.WASH_BUDGET_PER_MONTH),
              backgroundColor: hexToRgba(brandSuccess, 10),
              borderColor: brandSuccess,
              borderWidth: 2
            }
          ]

          this.chartData = {
            labels: arr.map(obj => obj.YEAR_MONTH),
            datasets: dataTmp
          }

          this.isFetching = false
        }
      )
    }
  },
}
</script>
